import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from "react";
import PropTypes from "prop-types";
import Chip from "../Chip";
export default class Selection extends Component {
  constructor(...args) {
    super(...args);
    _defineProperty(this, "onDelete", event => {
      const {
        onRemove,
        value
      } = this.props;
      event.preventDefault();
      event.stopPropagation();
      const val = value || this.props.data && this.props.data.value;
      onRemove(val);
    });
  }
  render() {
    const {
      id,
      children,
      onRemove
    } = this.props;
    if (onRemove) {
      return /*#__PURE__*/React.createElement(Chip, {
        id: id,
        tabIndex: -1,
        label: children,
        onDelete: this.onDelete
      });
    } else {
      return /*#__PURE__*/React.createElement("div", {
        id: id,
        className: "Select-value"
      }, children);
    }
  }
}
_defineProperty(Selection, "propTypes", {
  /**
   * The html id.
   */
  id: PropTypes.string,
  /**
   * The display contents of the selection element.
   */
  children: PropTypes.node,
  /**
   * If set, will display value as a Chip element with a clickable `Delete` icon
   */
  onRemove: PropTypes.func,
  /**
   * The value of the selected element.
   */
  value: PropTypes.any,
  /**
   * Object passed in by react-select containing information about the selected option.
   */
  data: PropTypes.object
});